import { ApiHelper } from './apiHelper/ApiHelper';
import { readJson } from './apiHelper/readJson';

// Faculties are static reference data (admin-edited rarely), so the list is
// fetched once per session and memoized here. The onboarding wizard, the account
// goal picker, and the practice model tests all read from this cache instead of
// re-fetching on each mount — so the dropdown, the saved goal, and the exam term
// render instantly instead of popping in after a network round-trip.
export type Faculty = {
    id: string;
    name: string;
    examDate: string | null;
    testModel: number;
    testLength: number;
};

let cache: Faculty[] | null = null;
let inflight: Promise<Faculty[]> | null = null;

// The already-resolved list, for initializing state synchronously on first
// render. Null until the first load completes.
export function getCachedFaculties(): Faculty[] | null {
    return cache;
}

// Loads the faculties once and reuses the result for the rest of the session.
// Concurrent callers share one in-flight request; a failed request is not cached
// so the next caller retries.
export async function loadFaculties(api: ApiHelper): Promise<Faculty[]> {
    if (cache) return cache;
    if (!inflight) {
        inflight = api.facultiesApi
            .getFacultiesList()
            .then((res) => readJson<Faculty[]>(res))
            .then((list) => {
                cache = list ?? [];
                return cache;
            })
            .catch((err) => {
                inflight = null;
                throw err;
            });
    }
    return inflight;
}
